var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00754 20.916H19.9853C20.2449 20.916 20.4999 20.8486 20.7256 20.7205C20.9513 20.5924 21.1398 20.4079 21.2729 20.1851C21.406 19.9623 21.4789 19.7088 21.4847 19.4493C21.4905 19.1899 21.4288 18.9334 21.3058 18.7049L13.3174 3.86898C12.7507 2.81711 11.2422 2.81711 10.6755 3.86898L2.68708 18.7049C2.56405 18.9334 2.50241 19.1899 2.50818 19.4493C2.51395 19.7088 2.58693 19.9623 2.71999 20.1851C2.85304 20.4079 3.04162 20.5924 3.2673 20.7205C3.49298 20.8486 3.74804 20.916 4.00754 20.916V20.916Z",
    stroke: "#C62704",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7346 9.15856L12.0036 14.8773L12.2722 9.1609C12.2739 9.12436 12.2681 9.08786 12.2551 9.05364C12.2422 9.01941 12.2224 8.98819 12.197 8.96186C12.1716 8.93554 12.1411 8.91467 12.1074 8.90054C12.0737 8.8864 12.0374 8.8793 12.0008 8.87965V8.87965C11.9649 8.88 11.9294 8.88755 11.8964 8.90185C11.8634 8.91615 11.8336 8.93691 11.8088 8.96291C11.784 8.98891 11.7646 9.01962 11.7519 9.05322C11.7391 9.08682 11.7332 9.12264 11.7346 9.15856V9.15856Z",
    stroke: "#C62704",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.6201C11.8146 18.6201 11.6333 18.5651 11.4792 18.4621C11.325 18.3591 11.2048 18.2127 11.1339 18.0414C11.0629 17.8701 11.0443 17.6816 11.0805 17.4997C11.1167 17.3179 11.206 17.1508 11.3371 17.0197C11.4682 16.8886 11.6352 16.7993 11.8171 16.7631C11.999 16.727 12.1875 16.7455 12.3588 16.8165C12.5301 16.8874 12.6765 17.0076 12.7795 17.1618C12.8825 17.3159 12.9375 17.4972 12.9375 17.6826C12.9375 17.9313 12.8387 18.1697 12.6629 18.3455C12.4871 18.5213 12.2486 18.6201 12 18.6201Z",
    fill: "#C62704"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOutline);
export default __webpack_public_path__ + "static/media/warning-outline.a9729453e9e0a18151b5d277f82f604d.svg";
export { ForwardRef as ReactComponent };